<template>
  <div class="activity-widget checkout">

    <!-- Checkout header -->
    <div style="display: flex; flex-direction: row; align-items: center; justify-content: center;">
      <img v-on:click="() => changePhase(-1)" style="flex: 1;" class="arrow" alt="left-arrow" :src="require('../assets/arrow-left.png')" />
      <h1 class="blue-text" style="flex: 2; text-align: center; font-size: 32px; margin-bottom: 0px; margin-top: 30px;">
        {{ getTranslation('ORDER_SUMMARY') }}
      </h1>
      <div style="flex: 1;" />
    </div>

    <!--div v-if="checkoutOptionsLoading" class="checkout-loading">
      <img
        style="height: 80px; width: 80px; padding: 10px; opacity: 0.8;"
        alt="loading-gif"
        :src="require('../assets/loader.gif')" />
    </div-->

    <!-- Payment failure message -->
    <div style="padding: 20px; background-color: rgb(255,215,215); margin: 20px; margin-bottom: 0px;" v-if="paymentFailureMessage">
      <p>{{ paymentFailureMessage }}</p>
    </div>

    <!-- Checkout content -->
    <div class="flex-container widget-content">
      <div class="flex-column" style="flex: 2; min-width: 55%;">

        <!-- IF NO QUESTIONS -->
        <div v-if="
          checkoutPhase === 0 &&
          activityBookings && activityBookings[0] &&
          activityBookings[0].questions &&
          !(
            activityBookings[0].questions.length > 0 ||
            extras && extras.perBooking && extras.perBooking.length > 0 ||
            (pickup || dropoff) && ( (pickup.places && pickup.places.length > 0) || (dropoff.places && dropoff.places.length > 0) ) ||
            activityBookings[0].passengers && activityBookings[0].passengers.filter(_ => _.passengerDetails.length > 0).length > 0
          )"
          class="box">
          <h3 class="box-title blue-text">{{ getTranslation('QUESTIONS_ABOUT_ORDER') }}</h3>
          <p style="padding: 10px; padding-bottom: 0px;">{{ getTranslation('NO_ADDITIONAL_QUESTIONS_ABOUT_THE_RESERVATION') }}</p>
        </div>

        <!-- Questions -->
        <div
          v-if="checkoutPhase === 0 && activityBookings && activityBookings[0] && activityBookings[0].questions && activityBookings[0].questions.length > 0"
          class="box"
          style="margin-top: 20px;">
          <h3 class="box-title blue-text">{{ getTranslation('QUESTIONS_ABOUT_ORDER') }}</h3>
          <div v-for="question in activityBookings[0].questions" :key="question.questionId" class="animate-render" style="padding: 10px; padding-top: 0px;">
            <h4 style="margin-bottom: 10px;" class="semi-title">{{ sanitizeText(question.label) }}</h4>
            <p v-if="question.help" style="margin-top: 0px;">{{ sanitizeText(question.help) }}</p>
            <input          
              :id="'questions-' + question.questionId"    
              v-if="
                !(question.dataType === 'INT') &&
                !(question.dataType === 'OPTIONS') &&
                !(question.dataType === 'BOOLEAN')
              "          
              :class="{
                'personal-info-field': true,
                'required': question.required,
                'requirements-filled': question.required && formValidations['questions-' + question.questionId]
              }"
              v-on:input="() => validateInput(question, 'questions-' + question.questionId)"
              v-model="formValues['questions-' + question.questionId]"
              :placeholder="getTranslation('INPUT_HERE')">
            <input
              :id="'questions-' + question.questionId"
              v-if="question.dataType === 'INT'"   
              v-on:input="() => validateInput(question, 'questions-' + question.questionId)"             
              :class="{
                'personal-information': true,
                'required': question.required,
                'requirements-filled': question.required && formValidations['questions-' + question.questionId]
              }"
              type="number"
              v-model="formValues['questions-' + question.questionId]">
            <select
              v-if="question.dataType === 'OPTIONS'"
              :id="'questions-' + question.questionId"
              v-model="formValues['questions-' + question.questionId]"
              v-on:change="() => validateInput(question, 'questions-' + question.questionId)"
              :class="{
                'required': question.required,
                'requirements-filled': question.required && formValidations['questions-' + question.questionId]
              }"
            >
              <option disabled :value="undefined">{{ getTranslation('CHOOSE') }}</option>
              <option v-for="answerOption in question.answerOptions" :key="answerOption.label" :value="answerOption.value">{{ answerOption.label }}</option>
            </select>
            <select
              v-if="question.dataType === 'BOOLEAN'"
              :id="'questions-' + question.questionId"
              v-model="formValues['questions-' + question.questionId]"
              v-on:change="() => validateInput(question, 'questions-' + question.questionId)"
              :class="{
                'required': question.required,
                'requirements-filled': question.required && formValidations['questions-' + question.questionId]
              }"
            >
              <option disabled :value="undefined">{{ getTranslation('CHOOSE') }}</option>
              <option :value="'true'">{{ getTranslation('YES') }}</option>
              <option :value="'false'">{{ getTranslation('NO') }}</option>
            </select>
          </div>
        </div>

        <!-- Extras -->
        <div v-if="checkoutPhase === 0 && activityBookings && activityBookings[0] && extras && extras.perBooking && extras.perBooking.length > 0" class="box" style="padding-bottom: 0px; margin-top: 20px;">
          <h3 class="box-title blue-text">{{ getTranslation('EXTRAS') }}</h3>
            <div v-if="extras && extras.perBooking" class="per-booking-extras">
              <div class="item-grid">
                <div class="item-container extra-container" v-for="(extra, bIndex) in extras.perBooking" :key="'booking-extra-' + bIndex">
                  <div class="item-information">
                    <h4 style="margin-bottom: 5px; margin-top: 10px;">{{ sanitizeText(extra.title + (extra.required ? ' *' : '')) }}</h4>
                    <p style="margin-top: 0px;">{{ sanitizeText(extra.description) }}</p>
                    <p style="margin-top: 0px;" v-if="extra.pricingType === 'INCLUDED_IN_PRICE'">{{ getTranslation('INCLUDED_IN_PRICE') }}</p>
                  </div>
                  <div v-if="extra.pricingType === 'PRICED_SEPARATELY'">
                    <div class="pricing-row">
                      <div style="flex: 1;">{{ extra.priceWithDiscountAsText }}</div>
                      <div v-if="!(extra.selectionType === 'PRESELECTED')">
                        <input
                          :id="'checkbox-booking-extra-' + bIndex"
                          type="checkbox"
                          style="min-width: 40px; display: none;"
                          v-model="formValues['checkbox-booking-extra-' + bIndex]"
                          v-on:change="() => {
                            checkExtras();
                            updateShoppingCartPrices();
                            setLatestButtonPressed('checkbox-booking-extra-' + bIndex)
                          }"
                          :true-value="extra"
                          :false-value="false"
                        />                        
                        <label
                          v-if="
                            !checkoutOptionsLoading ||
                            !(latestButtonPressed === ('checkbox-booking-extra-' + bIndex))
                          "
                          :class="{
                            'checkbox-btn': true,
                            'extra-button': true,
                            'delete-mode': formValues['checkbox-booking-extra-' + bIndex]
                          }"
                          :for="'checkbox-booking-extra-' + bIndex">                                                
                          {{ !formValues['checkbox-booking-extra-' + bIndex] ? getTranslation('ADD') : getTranslation('REMOVE') }}                          
                        </label>
                        <div
                          v-if="
                            checkoutOptionsLoading &&
                            (latestButtonPressed === ('checkbox-booking-extra-' + bIndex))
                          "
                          class="checkout-loading-container">
                          <img
                            class="checkout-loading-img"
                            alt="loading-gif"
                            :src="require('../assets/loader.gif')" />
                        </div>    
                      </div>
                      <div v-if="extra.selectionType === 'PRESELECTED'">
                        <input
                          :id="'checkbox-booking-extra-' + bIndex"
                          v-if="extra.selectionType === 'PRESELECTED'"
                          type="checkbox"
                          style="min-width: 40px; display: none;"
                          v-model="formValues['checkbox-booking-extra-' + bIndex]"                 
                          v-on:change="() => { checkExtras(); updateShoppingCartPrices() }"
                          :true-value="extra"
                          :false-value="extra"
                        />
                        <label
                          :class="{
                            'checkbox-btn': true,
                            'delete-mode': formValues['checkbox-booking-extra-' + bIndex],
                            'mandatory-button': extra.selectionType === 'PRESELECTED'
                          }"
                          :for="'checkbox-booking-extra-' + bIndex">
                          {{
                            extra.selectionType === 'PRESELECTED' ?
                              getTranslation('REQUIRED') :
                              (
                                !formValues['checkbox-booking-extra-' + bIndex] ?
                                  getTranslation('ADD') :
                                  getTranslation('REMOVE')
                              )
                          }}
                        </label>
                      </div>                  
                    </div>

                    <div class="item-additional-info-separator"></div>

                    <div class="item-additional-info">

                      <!-- Choose amounts -->
                      <!--h4 v-if="extra.maxPerBooking !== 1 && formValues['checkbox-booking-extra-' + bIndex]" style="padding-top: 10px;">{{ getTranslation('CHOOSE_AMOUNT') }}</h4-->
                      <div
                        style="margin-top: 30px; margin-bottom: 0px;"
                        class="animate-render"
                        v-if="extra.maxPerBooking !== 1 && formValues['checkbox-booking-extra-' + bIndex] && !extra.limitByPax">
                        <select
                          :id="'checkbox-booking-extra-' + bIndex + '-amount'"
                          v-model="formAmounts['checkbox-booking-extra-' + bIndex]"
                          v-on:change="() => { validateInput(null, 'checkbox-booking-extra-' + bIndex + '-amount'); updateShoppingCartPrices() }"
                          :class="{
                            'required': true,
                            'requirements-filled': formValidations['checkbox-booking-extra-' + bIndex + '-amount'] !== undefined
                          }"
                        >
                          <option disabled :value="undefined">{{ getTranslation('CHOOSE_AMOUNT') }}</option>
                          <option v-for="n in extra.maxPerBooking === 0 ? 25 : extra.maxPerBooking" :key="'amount-' + n" :value="n">{{ n }}</option>
                        </select>
                      </div>

                      <!--input
                        v-if="formValues['checkbox-booking-extra-' + bIndex]"   
                        :id="'checkbox-booking-extra-' + bIndex + 'input'"            
                        :class="{
                          'personal-information': true,
                          'required': extra.required,
                          'requirements-filled': extra.required && formValidations['checkbox-booking-extra-' + bIndex + 'input']
                        }"
                        style="margin-top: 20px;"
                        v-on:input="() => { validateInput(extra, 'checkbox-booking-extra-' + bIndex + 'input'); checkExtras() }"
                        v-model="formValues['checkbox-booking-extra-' + bIndex + 'input']"
                        :placeholder="getTranslation('ADDITIONAL_INFO_HERE')"-->

                      <!-- Filter extras additional questions -->
                      <div v-if="formValues['checkbox-booking-extra-' + bIndex] && bookingQuestions" style="padding-bottom: 10px;">                        
                        <div
                          v-for="question in bookingQuestions.filter(_ => _.extraId === extra.id).reduce((acc, val) => [ ...acc, ...val.questions ], [])"
                          :key="question.questionId"
                          class="animate-render"
                          style="padding-right: 10px; padding-top: 10px;">
                          <h4 style="margin-bottom: 5px;" class="semi-title">{{ sanitizeText(question.label + ( question.required ? ' *' : '' )) }}</h4>
                          <p v-if="question.help" style="margin-top: 0px;">{{ sanitizeText(question.help) }}</p>                
                          <input
                            :id="'checkbox-booking-extra-' + bIndex + 'input' + question.questionId"
                            v-if="question.dataType === 'SHORT_TEXT'"  
                            v-on:input="() => validateInput(question, 'checkbox-booking-extra-' + bIndex + 'input' + question.questionId)"              
                            :class="{
                              'personal-information': true,
                              'required': question.required,
                              'requirements-filled': question.required && formValidations['checkbox-booking-extra-' + bIndex + 'input' + question.questionId]
                            }"
                            v-model="formValues['checkbox-booking-extra-' + bIndex + 'input' + question.questionId]">
                          <input
                            :id="'checkbox-booking-extra-' + bIndex + 'input' + question.questionId"
                            v-if="question.dataType === 'INT'"   
                            v-on:input="() => validateInput(question, 'checkbox-booking-extra-' + bIndex + 'input' + question.questionId)"             
                            :class="{
                              'personal-information': true,
                              'required': question.required,
                              'requirements-filled': question.required && formValidations['checkbox-booking-extra-' + bIndex + 'input' + question.questionId]
                            }"
                            type="number"
                            v-model="formValues['checkbox-booking-extra-' + bIndex + 'input' + question.questionId]">
                          <select
                            v-if="question.dataType === 'OPTIONS'"
                            :id="'checkbox-booking-extra-' + bIndex + 'input' + question.questionId"
                            v-model="formValues['checkbox-booking-extra-' + bIndex + 'input' + question.questionId]"
                            v-on:change="() => validateInput(question, 'checkbox-booking-extra-' + bIndex + 'input' + question.questionId)"
                            :class="{
                              'required': question.required,
                              'requirements-filled': question.required && formValidations['checkbox-booking-extra-' + bIndex + 'input' + question.questionId]
                            }"
                          >
                            <option disabled :value="undefined">{{ getTranslation('CHOOSE') }}</option>
                            <option v-for="answerOption in question.answerOptions" :key="answerOption.label" :value="answerOption.value">{{ answerOption.label }}</option>
                          </select>
                          <select
                            v-if="question.dataType === 'BOOLEAN'"
                            :id="'checkbox-booking-extra-' + bIndex + 'input' + question.questionId"
                            v-model="formValues['checkbox-booking-extra-' + bIndex + 'input' + question.questionId]"
                            v-on:change="() => validateInput(question, 'checkbox-booking-extra-' + bIndex + 'input' + question.questionId)"
                            :class="{
                              'required': question.required,
                              'requirements-filled': question.required && formValidations['checkbox-booking-extra-' + bIndex + 'input' + question.questionId]
                            }"
                          >
                            <option disabled :value="undefined">{{ getTranslation('CHOOSE') }}</option>
                            <option :value="'true'">{{ getTranslation('YES') }}</option>
                            <option :value="'false'">{{ getTranslation('NO') }}</option>
                          </select>
                        </div>
                      </div>
                    </div>                    
                  </div>
                </div>
                <div v-if="extras.perBooking && (extras.perBooking.length % 2) === 1" class="item-container extra-container"></div>
              </div>       
            </div>
        </div>

       <!-- Pick-up and dropoff -->
        <div
          v-if="
            checkoutPhase === 0 &&
            activityBookings &&
            activityBookings[0] &&
            (pickup || dropoff) &&
            ( (pickup.places && pickup.places.length > 0) || (dropoff.places && dropoff.places.length > 0) ) &&
            !(pickup.selectionType === 'UNAVAILABLE' && dropoff.selectionType === 'UNAVAILABLE')
          " 
          class="box"
          style="padding-bottom: 0px; margin-top: 20px;">
          <h3 class="box-title blue-text">{{ getTranslation('TO_LOCATION_HOW') }}</h3>
          
          <div class="item-grid">
            
            <!-- Pick-up -->
            <div v-if="pickup && pickup.selectionType !== 'UNAVAILABLE'" class="pickup item-container extra-container">
              <div class="item-information" style="min-height: 50px;">
                <h4 style="margin-bottom: 5px; margin-top: 5px;">{{ getTranslation('TRANSPORTATION') }}</h4>
                <p style="margin-top: 0px;">{{ getTranslation('DO_YOU_WANT_TRANSPORTATION') }}</p>
              </div>
              <div>
                <div class="pricing-row" style="padding-bottom: 15px;">
                  <div style="flex: 1;" v-if="!(pickup.pricingType === 'INCLUDED_IN_PRICE')">{{ pickup.totalPrice }}</div>
                  <div style="flex: 1;" v-if="pickup.pricingType === 'INCLUDED_IN_PRICE'">{{ getTranslation('INCLUDED_IN_PRICE') }}</div>
                  <input
                    :id="'checkbox-pickup-wanted'"
                    type="checkbox"
                    style="min-width: 40px; display: none;"                    
                    v-on:change="() => {
                      updateShoppingCartPrices();
                      setLatestButtonPressed('checkbox-pickup-wanted')
                    }"
                    v-model="formValues['checkbox-pickup-wanted']"
                    :true-value="true"
                    :false-value="pickup.selectionType === 'PRESELECTED' ? true :false"
                  />
                  <label
                    v-if="
                      !checkoutOptionsLoading ||
                      !(latestButtonPressed === ('checkbox-pickup-wanted'))
                    "
                    :class="{
                      'checkbox-btn': true,
                      'delete-mode': formValues['checkbox-pickup-wanted'],
                      'mandatory-button': pickup.selectionType === 'PRESELECTED'
                    }"
                    :for="'checkbox-pickup-wanted'">
                    {{
                      pickup.selectionType === 'PRESELECTED' ?
                        getTranslation('REQUIRED') :
                        (
                          !formValues['checkbox-pickup-wanted'] ?
                            getTranslation('ADD') :
                            getTranslation('REMOVE')
                        )
                    }}
                  </label>  
                  <div
                    v-if="
                      checkoutOptionsLoading &&
                      (latestButtonPressed === ('checkbox-pickup-wanted'))
                    "
                    class="checkout-loading-container">
                    <img
                      class="checkout-loading-img"
                      alt="loading-gif"
                      :src="require('../assets/loader.gif')" />
                  </div>                  
                </div>

                <div class="item-additional-info-separator"></div>

                <div class="item-additional-info">
                  <!--p v-if="formValues['checkbox-pickup-wanted']" style="margin-top: 20px; margin-bottom: 5px;">{{ getTranslation('CHOOSE_A_PICK_UP_LOCATION') }}</p-->
                  <select
                    v-if="formValues['checkbox-pickup-wanted'] || pickup.selectionType === 'PRESELECTED'"
                    :id="'checkbox-pickup-select'"
                    style="margin-top: 30px;"
                    v-model="formValues['checkbox-pickup-selection']"
                    v-on:change="() => { validateInput(pickup, 'checkbox-pickup-selection'); setSelectedPickup(pickup, formValues['checkbox-pickup-selection']); updateShoppingCartPrices() }"
                    :class="{
                      'required': true,
                      'requirements-filled': formValidations['checkbox-pickup-selection']
                    }"
                  >
                    <option disabled :value="undefined">{{ getTranslation('CHOOSE_A_PICK_UP_PLACE') + ' *' }}</option>
                    <option
                      v-for="place in pickup.places"
                      :key="place.id"
                      :value="place"
                    >
                      {{ place.title }}
                    </option>
                  </select>
                  <p style="padding: 5px;" v-if="selectedPickup && formValues['checkbox-pickup-wanted'] && pickupTimeByLocations && (pickupTimeByLocations.filter(_ => _.placeId === selectedPickup.id)[0] || pickupMinutesBefore)">{{ getTranslation('BE_READY_PICKUP_PART_1') + ' ' + ((pickupTimeByLocations.filter(_ => _.placeId === selectedPickup.id)[0] && pickupTimeByLocations.filter(_ => _.placeId === selectedPickup.id)[0].minBeforeStart) || pickupMinutesBefore) + ' ' + getTranslation('BE_READY_PICKUP_PART_2') }}</p>
                  <div
                    v-if="pickupQuestions && pickupQuestions.length > 0"
                    class="transportation-questions-container animate-render">
                    <div v-for="question in pickupQuestions" :key="question.questionId" style="padding-top: 0px;" class="animate-render">
                      <h4 style="margin-bottom: 10px;" class="semi-title">{{ sanitizeText(question.label) }}</h4>
                      <p v-if="question.help" style="margin-top: 0px;">{{ sanitizeText(question.help) }}</p>
                      
                      <!-- Normal text datatype -->
                      <input          
                        :id="'pickup-question' + question.questionId"    
                        v-if="
                          !(question.dataType === 'INT') &&
                          !(question.dataType === 'OPTIONS') &&
                          !(question.dataType === 'BOOLEAN')
                        "          
                        :class="{
                          'personal-info-field': true,
                          'required': question.required,
                          'requirements-filled': question.required && formValidations['pickup-question' + question.questionId]
                        }"
                        v-on:input="() => validateInput(question, 'pickup-question' + question.questionId)"
                        v-model="formValues['pickup-question' + question.questionId]"
                        :placeholder="getTranslation('INPUT_HERE')">

                        <!--Integer datatype -->
                      <input
                        :id="'pickup-question' + question.questionId"
                        v-if="question.dataType === 'INT'"   
                        v-on:input="() => validateInput(question, 'pickup-question' + question.questionId)"             
                        :class="{
                          'personal-information': true,
                          'required': question.required,
                          'requirements-filled': question.required && formValidations['pickup-question' + question.questionId]
                        }"
                        type="number"
                        v-model="formValues['pickup-question' + question.questionId]">

                      <!-- Options datatype -->
                      <select
                        v-if="question.dataType === 'OPTIONS'"
                        :id="'pickup-question' + question.questionId"
                        v-model="formValues['pickup-question' + question.questionId]"
                        v-on:change="() => validateInput(question, 'pickup-question' + question.questionId)"
                        :class="{
                          'required': question.required,
                          'requirements-filled': question.required && formValidations['pickup-question' + question.questionId]
                        }"
                      >
                        <option disabled :value="undefined">{{ getTranslation('CHOOSE') }}</option>
                        <option v-for="answerOption in question.answerOptions" :key="answerOption.label" :value="answerOption.value">{{ answerOption.label }}</option>
                      </select>

                      <!-- Boolean datatype -->
                      <select
                        v-if="question.dataType === 'BOOLEAN'"
                        :id="'pickup-question' + question.questionId"
                        v-model="formValues['pickup-question' + question.questionId]"
                        v-on:change="() => validateInput(question, 'pickup-question' + question.questionId)"
                        :class="{
                          'required': question.required,
                          'requirements-filled': question.required && formValidations['pickup-question' + question.questionId]
                        }"
                      >
                        <option disabled :value="undefined">{{ getTranslation('CHOOSE') }}</option>
                        <option :value="'true'">{{ getTranslation('YES') }}</option>
                        <option :value="'false'">{{ getTranslation('NO') }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>              
            </div>

            <!-- Dropoff -->
            <div v-if="dropoff && dropoff.selectionType !== 'UNAVAILABLE'" class="dropoff item-container extra-container">
              <div class="item-information" style="min-height: 50px;">
                <h4 style="margin-bottom: 5px; margin-top: 5px;">{{ getTranslation('LEAVING_HOW') }}</h4>
                <p style="margin-top: 0px;">{{ getTranslation('DO_YOU_WANT_TRANSPORTATION') }}</p>
              </div>
              <div>
                <div class="pricing-row" style="padding-bottom: 15px;">
                  <div style="flex: 1;" v-if="!(dropoff.pricingType === 'INCLUDED_IN_PRICE')">{{ dropoff.totalPrice }}</div>
                  <div style="flex: 1;" v-if="dropoff.pricingType === 'INCLUDED_IN_PRICE'">{{ getTranslation('INCLUDED_IN_PRICE') }}</div>
                  <input
                    :id="'checkbox-dropoff-wanted'"
                    type="checkbox"
                    style="min-width: 40px; display: none;"
                    v-on:change="() => {
                      updateShoppingCartPrices();
                      setLatestButtonPressed('checkbox-dropoff-wanted')
                    }"
                    v-model="formValues['checkbox-dropoff-wanted']"
                    :true-value="true"
                    :false-value="dropoff.selectionType === 'PRESELECTED' ? true :false"
                  />
                  <label
                    v-if="
                      !checkoutOptionsLoading ||
                      !(latestButtonPressed === ('checkbox-dropoff-wanted'))
                    "
                    :class="{
                      'checkbox-btn': true,
                      'delete-mode': formValues['checkbox-dropoff-wanted'],
                      'mandatory-button': dropoff.selectionType === 'PRESELECTED'
                    }"
                    :for="'checkbox-dropoff-wanted'">
                    {{
                      dropoff.selectionType === 'PRESELECTED' ?
                        getTranslation('REQUIRED') :
                        (
                          !formValues['checkbox-dropoff-wanted'] ?
                            getTranslation('ADD') :
                            getTranslation('REMOVE')
                        )
                    }}
                  </label>   
                  <div
                    v-if="
                      checkoutOptionsLoading &&
                      (latestButtonPressed === ('checkbox-dropoff-wanted'))
                    "
                    class="checkout-loading-container">
                    <img
                      class="checkout-loading-img"
                      alt="loading-gif"
                      :src="require('../assets/loader.gif')" />
                  </div>              
                </div>

                <div class="item-additional-info-separator"></div>

                <div class="item-additional-info">
                  <!--p v-if="formValues['checkbox-dropoff-wanted']" style="margin-top: 10px; margin-bottom: 5px;">{{ getTranslation('CHOOSE_A_PICK_UP_LOCATION') }}</p-->
                  <select
                    v-if="formValues['checkbox-dropoff-wanted'] || dropoff.selectionType === 'PRESELECTED'"
                    :id="'checkbox-dropoff-select'"
                    style="margin-top: 30px;"
                    v-model="formValues['checkbox-dropoff-selection']"
                    v-on:change="() => { validateInput(dropoff, 'checkbox-dropoff-selection'); setSelectedDropoff(dropoff, formValues['checkbox-dropoff-selection']); updateShoppingCartPrices() }"
                    :class="{
                      'required': true,
                      'requirements-filled': formValidations['checkbox-dropoff-selection']
                    }"
                  >
                    <option disabled :value="undefined">{{ getTranslation('CHOOSE_A_DROP_OFF_LOCATION') + ' *' }}</option>
                    <option
                      v-for="place in dropoff.places"
                      :key="place.id"
                      :value="place"
                    >
                      {{ place.title }}
                    </option>
                  </select>  
                  <div
                    class="transportation-questions-container animate-render"
                    v-if="dropoffQuestions && dropoffQuestions.length > 0">
                    <div v-for="question in dropoffQuestions" :key="question.questionId" style="padding-top: 0px;" class="animate-render">
                      <h4 style="margin-bottom: 10px;" class="semi-title">{{ sanitizeText(question.label) }}</h4>
                      <p v-if="question.help" style="margin-top: 0px;">{{ sanitizeText(question.help) }}</p>
                      
                      <!-- Normal text datatype -->
                      <input          
                        :id="'dropoff-question' + question.questionId"    
                        v-if="
                          !(question.dataType === 'INT') &&
                          !(question.dataType === 'OPTIONS') &&
                          !(question.dataType === 'BOOLEAN')
                        "          
                        :class="{
                          'personal-info-field': true,
                          'required': question.required,
                          'requirements-filled': question.required && formValidations['dropoff-question' + question.questionId]
                        }"
                        v-on:input="() => validateInput(question, 'dropoff-question' + question.questionId)"
                        v-model="formValues['dropoff-question' + question.questionId]"
                        :placeholder="getTranslation('INPUT_HERE')">

                        <!--Integer datatype -->
                      <input
                        :id="'dropoff-question' + question.questionId"
                        v-if="question.dataType === 'INT'"   
                        v-on:input="() => validateInput(question, 'dropoff-question' + question.questionId)"             
                        :class="{
                          'personal-information': true,
                          'required': question.required,
                          'requirements-filled': question.required && formValidations['dropoff-question' + question.questionId]
                        }"
                        type="number"
                        v-model="formValues['dropoff-question' + question.questionId]">

                      <!-- Options datatype -->
                      <select
                        v-if="question.dataType === 'OPTIONS'"
                        :id="'dropoff-question' + question.questionId"
                        v-model="formValues['dropoff-question' + question.questionId]"
                        v-on:change="() => validateInput(question, 'dropoff-question' + question.questionId)"
                        :class="{
                          'required': question.required,
                          'requirements-filled': question.required && formValidations['dropoff-question' + question.questionId]
                        }"
                      >
                        <option disabled :value="undefined">{{ getTranslation('CHOOSE') }}</option>
                        <option v-for="answerOption in question.answerOptions" :key="answerOption.label" :value="answerOption.value">{{ answerOption.label }}</option>
                      </select>

                      <!-- Boolean datatype -->
                      <select
                        v-if="question.dataType === 'BOOLEAN'"
                        :id="'dropoff-question' + question.questionId"
                        v-model="formValues['dropoff-question' + question.questionId]"
                        v-on:change="() => validateInput(question, 'dropoff-question' + question.questionId)"
                        :class="{
                          'required': question.required,
                          'requirements-filled': question.required && formValidations['dropoff-question' + question.questionId]
                        }"
                      >
                        <option disabled :value="undefined">{{ getTranslation('CHOOSE') }}</option>
                        <option :value="'true'">{{ getTranslation('YES') }}</option>
                        <option :value="'false'">{{ getTranslation('NO') }}</option>
                      </select>
                    </div>
                  </div>            
                </div>  
              </div>              
            </div>
          </div>
        </div>

        <!-- Participants -->
        <div v-if="checkoutPhase === 0 && activityBookings && activityBookings[0] && activityBookings[0].passengers && (activityBookings[0].passengers.filter(_ => _.passengerDetails.length > 0).length > 0 || activityBookings[0].passengers.filter(_ => _.questions.length > 0).length > 0 || (extras && extras.perPerson && extras.perPerson.length > 0) )" class="box" style="padding-bottom: 0px; margin-top: 20px;">
          <h3 class="box-title blue-text">{{ getTranslation('PARTICIPANTS_CHECKOUT') }}</h3>
          <div v-for="(participant, index) in activityBookings[0].passengers" :key="participant.pricingCategoryTitle + '-' + index">
            
            <div
              :class="{                
                'passenger-title-container': true,
                'collapsed-dropdown-header': !sectionClosed['participant-' + index]      
              }"
              v-on:click="() => handleSectionClick('participant-' + index)">
              <h4
                style="flex: 1; margin-bottom: 0px; margin-top: 0px; padding-bottom: 15px; padding-top: 15px;"
                class="semi-title">
                {{ getTranslation('PARTICIPANT') + ' ' + (index + 1) + ' (' + participant.pricingCategoryTitle + ')' }}
              </h4>
              <div>
                {{ sectionClosed['participant-' + index] ? getTranslation('OPEN_PARTICIPANT') : getTranslation('CLOSE_PARTICIPANT')  }}
              </div>
            </div>

            <div
              :class="{                
                'passenger-content-container': !sectionClosed['participant-' + index],
                'collapsed': sectionClosed['participant-' + index]            
              }">        

              <!-- Passenger information -->
              <div class="passenger-information" style="padding-bottom: 20px;" v-if="participant.passengerDetails && participant.passengerDetails.length > 0">
                <div
                  v-for="passengerQuestion in participant.passengerDetails"
                  :key="'passenger-' + index + '-question-' + passengerQuestion.questionId"
                  class="tooltip-container animate-render"
                  style="display: inline-block;">
                  <span v-if="getTooltip(passengerQuestion)" class="tooltip">
                    {{ getTooltip(passengerQuestion) }}
                  </span>
                  <input    
                    :id="'passenger-' + index + '-question-' + passengerQuestion.questionId"          
                    :class="{
                      'personal-information': true,
                      'required': passengerQuestion.required,
                      'requirements-filled': passengerQuestion.required && formValidations['passenger-' + index + '-question-' + passengerQuestion.questionId]
                    }"    
                    v-if="!(passengerQuestion.dataFormat === 'LANGUAGE') && !(passengerQuestion.dataFormat === 'PHONE_NUMBER')"            
                    v-on:input="() => validateInput(passengerQuestion, 'passenger-' + index + '-question-' + passengerQuestion.questionId)"
                    v-model="formValues['passenger-' + index + '-question-' + passengerQuestion.questionId]"
                    :placeholder="passengerQuestion.label + ( passengerQuestion.label === 'Syntymäaika' ? ' (pp.kk.vvvv)' : '' ) + ( passengerQuestion.label === 'Date of birth' ? ' (dd.mm.yyyy)' : '' ) + ( passengerQuestion.required ? ' *' : '' )">
                  <select
                    v-if="passengerQuestion.dataType === 'OPTIONS' || passengerQuestion.dataFormat === 'LANGUAGE'"
                    :id="'passenger-' + index + '-question-' + passengerQuestion.questionId"
                    style="margin-right: 5px; margin-bottom: 5px; max-width: 274px;"
                    v-model="formValues['passenger-' + index + '-question-' + passengerQuestion.questionId]"
                    v-on:change="() => validateInput(passengerQuestion, 'passenger-' + index + '-question-' + passengerQuestion.questionId)"
                    :class="{
                      'required': passengerQuestion.required,
                      'requirements-filled': passengerQuestion.required && formValidations['passenger-' + index + '-question-' + passengerQuestion.questionId]
                    }"
                  >
                    <option disabled :value="undefined">{{ passengerQuestion.label + ( passengerQuestion.required ? ' *' : '' )  }}</option>
                    <option v-for="answerOption in passengerQuestion.answerOptions.filter(_ => _.value).sort(compareNationalitiesForSort)" :key="answerOption.label" :value="answerOption.value">{{ answerOption.label }}</option>
                  </select>
                  <div
                    v-if="passengerQuestion.dataFormat === 'PHONE_NUMBER'"
                    style="display: flex; flex-direction: row;">
                    <select
                      :class="{'areacode-select': true}"   
                      v-on:change="() => validateInput(passengerQuestion, 'passenger-' + index + '-question-' + passengerQuestion.questionId)"                   
                      v-model="formValues['passenger-' + index + '-question-areacode']">
                      <option disabled :value="undefined">{{ getTranslation('ISO') }}</option>
                      <option v-for="areaCode in areaCodes" :key="areaCode.name" :value="areaCode.Iso">{{ '(' + areaCode.Iso + ') ' + areaCode.name }}</option>
                    </select>
                    <input
                      :id="'passenger-' + index + '-question-' + passengerQuestion.questionId"            
                      style="min-width: 162px;"
                      :class="{
                        'personal-information': true,
                        'required': passengerQuestion.required,
                        'requirements-filled': passengerQuestion.required && formValidations['passenger-' + index + '-question-' + passengerQuestion.questionId]
                      }"       
                      v-on:input="(_) => validateInput(passengerQuestion, 'passenger-' + index + '-question-' + passengerQuestion.questionId)"
                      v-model="formValues['passenger-' + index + '-question-' + passengerQuestion.questionId]"
                      :placeholder="passengerQuestion.label + ( passengerQuestion.label === 'Syntymäaika' ? ' (pp.kk.vvvv)' : '' ) + ( passengerQuestion.label === 'Date of birth' ? ' (dd.mm.yyyy)' : '' ) + ( passengerQuestion.required ? ' *' : '' )">
                  </div>
                </div>  
              </div>                        

              <!-- Extras per participant -->
              <div
                v-if="extras && extras.perPerson && extras.perPerson.filter(_ => _.pricingCategoryId === participant.pricingCategoryId).length > 0"
                class="per-person-extras animate-render">
                <h3 class="box-title blue-text" style="padding-left: 0px;">{{ getTranslation('PARTICIPANT_EXTRAS') }}</h3>
                <div v-for="(extra, eIndex) in extras.perPerson" :key="'extra-' + index + '-' + eIndex">
                  <div
                    v-if="participant.pricingCategoryId === extra.pricingCategoryId"
                    class="item-grid"
                    style="margin-bottom: 5px;">
                    <div
                      v-for="(individualExtra, iExtraIndex) in extra.extrasWithPrices"
                      :key="'indExtra-' + index + '-' + eIndex + '-' + iExtraIndex"
                      class="item-container animate-render"
                      style="padding-right: 20px; padding-bottom: 10px;">
                      <h4 style="margin-bottom: 5px; margin-top: 10px;">{{ sanitizeText(individualExtra.title) }}</h4>
                      <p style="margin-top: 0px;">{{ sanitizeText(individualExtra.description) }}</p>
                      <p style="margin-top: 0px;" v-if="individualExtra.pricingType === 'INCLUDED_IN_PRICE'">{{ getTranslation('INCLUDED_IN_PRICE') }}</p>
                      <div v-if="individualExtra.pricingType === 'PRICED_SEPARATELY'">
                        <div>
                          <div style="margin-bottom: 30px;">{{ individualExtra.priceWithDiscountAsText }}</div>
                          <div v-if="!(individualExtra.selectionType === 'PRESELECTED')">
                            <input
                              :id="'checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex"
                              type="checkbox"
                              style="min-width: 40px; display: none;"
                              v-model="formValues['checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex]"
                              v-on:change="() => {
                                checkExtras();
                                updateShoppingCartPrices();
                                setLatestButtonPressed('checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex)
                              }"
                              :true-value="individualExtra"
                              :false-value="false"
                            />
                            <label
                              v-if="
                                !checkoutOptionsLoading ||
                                !(latestButtonPressed === ('checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex))
                              "
                              :class="{
                                'checkbox-btn': true,
                                'delete-mode': formValues['checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex]
                              }"
                              :for="'checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex">
                              {{ !formValues['checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex] ? getTranslation('ADD') : getTranslation('REMOVE') }}
                            </label>  
                            <div
                              v-if="
                                checkoutOptionsLoading &&
                                (latestButtonPressed === ('checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex))
                              "
                              class="checkout-loading-container">
                              <img
                                class="checkout-loading-img"
                                alt="loading-gif"
                                :src="require('../assets/loader.gif')" />
                            </div>  
                          </div>
                          <div v-if="individualExtra.selectionType === 'PRESELECTED'">
                            <input
                              :id="'checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex"
                              v-if="individualExtra.selectionType === 'PRESELECTED'"
                              type="checkbox"
                              style="min-width: 40px; display: none;"
                              v-model="formValues['checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex]"                 
                              v-on:change="() => { checkExtras(); updateShoppingCartPrices() }"
                              :true-value="individualExtra"
                              :false-value="individualExtra"
                            />
                            <label
                              :class="{
                                'checkbox-btn': true,
                                'delete-mode': formValues['checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex],
                                'mandatory-button': individualExtra.selectionType === 'PRESELECTED'
                              }"
                              :for="'checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex">
                              {{
                                individualExtra.selectionType === 'PRESELECTED' ?
                                  getTranslation('REQUIRED') :
                                  (
                                    !formValues['checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex] ?
                                      getTranslation('ADD') :
                                      getTranslation('REMOVE')
                                  )
                              }}
                            </label>
                          </div> 
                        </div>

                        <!-- Choose amounts -->
                        <!--h4 v-if="individualExtra.maxPerBooking !== 1 && formValues['checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex]" style="padding-top: 10px;">{{ getTranslation('CHOOSE_AMOUNT') }}</h4-->
                        <div
                          style="margin-top: 30px; margin-bottom: 30px;"
                          class="animate-render"
                          v-if="individualExtra.maxPerBooking !== 1 && formValues['checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex] && !individualExtra.limitByPax">
                          <select
                            :id="'checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex + '-amount'"
                            v-model="formAmounts['checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex]"
                            v-on:change="() => { validateInput(null, 'checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex + '-amount'); updateShoppingCartPrices() }"
                            :class="{
                              'required': true,
                              'requirements-filled': formValidations['checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex + '-amount'] !== undefined
                            }"
                          >
                            <option disabled :value="undefined">{{ getTranslation('CHOOSE_AMOUNT') }}</option>
                            <option v-for="n in individualExtra.maxPerBooking === 0 ? 25 : individualExtra.maxPerBooking" :key="'amount-' + n" :value="n">{{ n }}</option>
                          </select>
                        </div>

                        <!--input
                          :id="'checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex + 'input'"
                          v-if="formValues['checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex]"                
                          :class="{
                            'personal-information': true,
                            'required': individualExtra.required,
                            'requirements-filled': individualExtra.required && formValidations['checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex + 'input']
                          }"
                          style="margin-top: 20px;"
                          v-model="formValues['checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex + 'input']"
                          :placeholder="getTranslation('ADDITIONAL_INFO_HERE')"-->
                                               
                        <!-- Filter extras additional questions -->
                        <div v-if="formValues['checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex] && participant && participant.extras && participant.extras.length > 0">
                          <div style="margin-top: 30px;" />
                          <div
                            v-for="question in participant.extras.filter(_ => _.extraId === individualExtra.id )[0] && participant.extras.filter(_ => _.extraId === individualExtra.id )[0].questions"
                            :key="question.questionId"
                            class="animate-render"
                            style="padding-right: 10px; padding-bottom: 10px;">
                            <h4 style="margin-bottom: 5px;" class="semi-title">{{ sanitizeText(question.label + ( question.required ? ' *' : '' )) }}</h4>
                            <p v-if="question.help" style="margin-top: 0px;">{{ sanitizeText(question.help) }}</p>                
                            <input
                              :id="'checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex + 'input' + question.questionId"
                              v-if="question.dataType === 'SHORT_TEXT'"  
                              v-on:input="() => validateInput(question, 'checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex + 'input' + question.questionId)"              
                              :class="{
                                'personal-information': true,
                                'required': question.required,
                                'requirements-filled': question.required && formValidations['checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex + 'input' + question.questionId]
                              }"
                              v-model="formValues['checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex + 'input' + question.questionId]">
                            <input
                              :id="'checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex + 'input' + question.questionId"
                              v-if="question.dataType === 'INT'"   
                              v-on:input="() => validateInput(question, 'checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex + 'input' + question.questionId)"             
                              :class="{
                                'personal-information': true,
                                'required': question.required,
                                'requirements-filled': question.required && formValidations['checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex + 'input' + question.questionId]
                              }"
                              type="number"
                              v-model="formValues['checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex + 'input' + question.questionId]">
                            <select
                              v-if="question.dataType === 'OPTIONS'"
                              :id="'checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex + 'input' + question.questionId"
                              v-model="formValues['checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex + 'input' + question.questionId]"
                              v-on:change="() => validateInput(question, 'checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex + 'input' + question.questionId)"
                              :class="{
                                'required': question.required,
                                'requirements-filled': question.required && formValidations['checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex + 'input' + question.questionId]
                              }"
                            >
                              <option disabled :value="undefined">{{ getTranslation('CHOOSE') }}</option>
                              <option v-for="answerOption in question.answerOptions" :key="answerOption.label" :value="answerOption.value">{{ answerOption.label }}</option>
                            </select>
                            <select
                              v-if="question.dataType === 'BOOLEAN'"
                              :id="'checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex + 'input' + question.questionId"
                              v-model="formValues['checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex + 'input' + question.questionId]"
                              v-on:change="() => validateInput(question, 'checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex + 'input' + question.questionId)"
                              :class="{
                                'required': question.required,
                                'requirements-filled': question.required && formValidations['checkbox-indExtra-' + index + '-' + eIndex + '-' + iExtraIndex + 'input' + question.questionId]
                              }"
                            >
                              <option disabled :value="undefined">{{ getTranslation('CHOOSE') }}</option>
                              <option :value="'true'">{{ getTranslation('YES') }}</option>
                              <option :value="'false'">{{ getTranslation('NO') }}</option>
                            </select>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>              
              </div>

              <!-- Passenger questions -->
              <div style="padding-top: 20px;" v-if="participant.questions && participant.questions.length > 0">
                <h3 class="box-title blue-text" style="padding-left: 0px;">{{ getTranslation('ADDITIONAL_QUESTIONS') }}</h3>
                <div class="item-grid">                  
                  <div
                    v-for="question in participant.questions"
                    :key="question.questionId"
                    class="item-container animate-render"
                    style="padding-right: 10px; padding-bottom: 10px;">
                    <h4 style="margin-bottom: 5px;" class="semi-title">{{ sanitizeText(question.label + ( question.required ? ' *' : '' )) }}</h4>
                    <p v-if="question.help" style="margin-top: 0px;">{{ sanitizeText(question.help) }}</p>                
                    <input
                      :id="'passenger-' + index + '-question-' + question.questionId"
                      v-if="question.dataType === 'SHORT_TEXT'"  
                      v-on:input="() => validateInput(question, 'passenger-' + index + '-question-' + question.questionId)"              
                      :class="{
                        'personal-information': true,
                        'required': question.required,
                        'requirements-filled': question.required && formValidations['passenger-' + index + '-question-' + question.questionId]
                      }"
                      v-model="formValues['passenger-' + index + '-question-' + question.questionId]">
                    <input
                      :id="'passenger-' + index + '-question-' + question.questionId"
                      v-if="question.dataType === 'INT'"   
                      v-on:input="() => validateInput(question, 'passenger-' + index + '-question-' + question.questionId)"             
                      :class="{
                        'personal-information': true,
                        'required': question.required,
                        'requirements-filled': question.required && formValidations['passenger-' + index + '-question-' + question.questionId]
                      }"
                      type="number"
                      v-model="formValues['passenger-' + index + '-question-' + question.questionId]">
                    <select
                      v-if="question.dataType === 'OPTIONS'"
                      :id="'passenger-' + index + '-question-' + question.questionId"
                      v-model="formValues['passenger-' + index + '-question-' + question.questionId]"
                      v-on:change="() => validateInput(question, 'passenger-' + index + '-question-' + question.questionId)"
                      :class="{
                        'required': question.required,
                        'requirements-filled': question.required && formValidations['passenger-' + index + '-question-' + question.questionId]
                      }"
                    >
                      <option disabled :value="undefined">{{ getTranslation('CHOOSE') }}</option>
                      <option v-for="answerOption in question.answerOptions" :key="answerOption.label" :value="answerOption.value">{{ answerOption.label }}</option>
                    </select>
                    <select
                      v-if="question.dataType === 'BOOLEAN'"
                      :id="'passenger-' + index + '-question-' + question.questionId"
                      v-model="formValues['passenger-' + index + '-question-' + question.questionId]"
                      v-on:change="() => validateInput(question, 'passenger-' + index + '-question-' + question.questionId)"
                      :class="{
                        'required': question.required,
                        'requirements-filled': question.required && formValidations['passenger-' + index + '-question-' + question.questionId]
                      }"
                    >
                      <option disabled :value="undefined">{{ getTranslation('CHOOSE') }}</option>
                      <option :value="'true'">{{ getTranslation('YES') }}</option>
                      <option :value="'false'">{{ getTranslation('NO') }}</option>
                    </select>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- Contact person information -->
        <div v-if="checkoutPhase === 1" class="box">          
          <h3 class="box-title blue-text">{{ getTranslation('CONTACT_INFORMATION') }}</h3>
          <div style="padding: 10px; padding-top: 20px; max-width: 600px;">
            <!-- Checkbox to autofill contact information from 1st participant  -->
            <!--div style="display: flex; flex-direction: row; align-items: center; padding: 20px; padding-left: 10px;">
              <input
                type="checkbox"
                style="width: 15px; height: 15px; min-width: 15px;"
                id="contactPersonSameAsFirstParticipant-selection"
                name="contactPersonSameAsFirstParticipant"
                v-model="contactPersonSameAsFirstParticipant"
                v-on:input="() => {!contactPersonSameAsFirstParticipant ?
                    autofillContactPersonFromParticipants() :
                    () => {};
                  setContactPersonSameAsFirstParticipant(!contactPersonSameAsFirstParticipant)
                }">
              <div
                style="padding-left: 10px;"   
                v-on:click="() => {!contactPersonSameAsFirstParticipant ?
                    autofillContactPersonFromParticipants() :
                    () => {};
                  setContactPersonSameAsFirstParticipant(!contactPersonSameAsFirstParticipant)
                }">{{ getTranslation('CONTACT_PERSON_IS_SAME_AS_PARTICIPANT_1') }}</div>            
            </div-->
            <h4 style="padding-left: 10px; margin-top: 0px;" class="semi-title">{{ getTranslation('CONTACT_PERSON_DETAILS') }}</h4>
            <div
              v-for="contactQuestion in contactQuestions"
              :key="'mainContactDetails-' + contactQuestion.questionId"
              class="tooltip-container"
              style="display: inline-block;">
              <span v-if="getTooltip(contactQuestion)" class="tooltip">
                {{ getTooltip(contactQuestion) }}
              </span>
              <input
                :id="'mainContactDetails-' + contactQuestion.questionId"            
                :class="{
                  'personal-information': true,
                  'editing-disabled': contactPersonSameAsFirstParticipant,
                  'required': contactQuestion.required,
                  'requirements-filled': contactQuestion.required && formValidations['mainContactDetails-' + contactQuestion.questionId]
                }"
                :disabled="contactPersonSameAsFirstParticipant"
                v-if="!(contactQuestion.dataFormat === 'LANGUAGE') && !contactQuestion.selectFromOptions && !(contactQuestion.dataFormat === 'PHONE_NUMBER')"
                v-on:input="() => validateInput(contactQuestion, 'mainContactDetails-' + contactQuestion.questionId)"
                v-model="formValues['mainContactDetails-' + contactQuestion.questionId]"
                :placeholder="contactQuestion.label + ( contactQuestion.label === 'Syntymäaika' ? ' (pp.kk.vvvv)' : '' ) + ( contactQuestion.label === 'Date of birth' ? ' (dd.mm.yyyy)' : '' ) + ( contactQuestion.required ? ' *' : '' )">
              <select
                v-if="contactQuestion.dataType === 'OPTIONS' || contactQuestion.dataFormat === 'LANGUAGE' || contactQuestion.selectFromOptions"
                :id="'mainContactDetails-' + contactQuestion.questionId"
                style="margin-right: 5px; margin-bottom: 5px; max-width: 274px;"
                :disabled="contactPersonSameAsFirstParticipant"
                v-model="formValues['mainContactDetails-' + contactQuestion.questionId]"
                v-on:change="() => validateInput(contactQuestion, 'mainContactDetails-' + contactQuestion.questionId)"
                :class="{
                  'required': contactQuestion.required,
                  'editing-disabled': contactPersonSameAsFirstParticipant,
                  'requirements-filled': contactQuestion.required && formValidations['mainContactDetails-' + contactQuestion.questionId]
                }"
              >
                <option disabled :value="undefined">{{ contactQuestion.label + ( contactQuestion.required ? ' *' : '' ) }}</option>
                <option v-for="answerOption in contactQuestion.answerOptions.filter(_ => _.value).sort(compareNationalitiesForSort)" :key="answerOption.label" :value="answerOption.value">{{ answerOption.label }}</option>
              </select>
              <div
                v-if="contactQuestion.dataFormat === 'PHONE_NUMBER'"
                style="display: flex; flex-direction: row;">
                <select
                  :class="{
                    'areacode-select': true,
                    'editing-disabled': contactPersonSameAsFirstParticipant
                  }"
                  :disabled="contactPersonSameAsFirstParticipant"
                  v-on:change="() => validateInput(contactQuestion, 'mainContactDetails-' + contactQuestion.questionId)"                   
                  v-model="formValues['mainContactDetails-' + 'areacode']">
                  <option disabled :value="undefined">{{ getTranslation('ISO') }}</option>
                  <option v-for="areaCode in areaCodes" :key="areaCode.name" :value="areaCode.Iso">{{ '(' + areaCode.Iso + ') ' + areaCode.name }}</option>
                </select>
                <input
                  :id="'mainContactDetails-' + contactQuestion.questionId"            
                  style="min-width: 162px;"
                  :class="{
                    'personal-information': true,
                    'editing-disabled': contactPersonSameAsFirstParticipant,
                    'required': contactQuestion.required,
                    'requirements-filled': contactQuestion.required && formValidations['mainContactDetails-' + contactQuestion.questionId]
                  }"
                  :disabled="contactPersonSameAsFirstParticipant"                  
                  v-on:input="(_) => validateInput(contactQuestion, 'mainContactDetails-' + contactQuestion.questionId)"
                  v-model="formValues['mainContactDetails-' + contactQuestion.questionId]"
                  :placeholder="contactQuestion.label + ( contactQuestion.label === 'Syntymäaika' ? ' (pp.kk.vvvv)' : '' ) + ( contactQuestion.label === 'Date of birth' ? ' (dd.mm.yyyy)' : '' ) + ( contactQuestion.required ? ' *' : '' )">
              </div>
            </div>   
          </div>          
        </div>

        <!-- Payment -->
        <div v-if="checkoutPhase === 2" class="box">
          <h3 class="box-title blue-text">{{ getTranslation('PAYMENT') }}</h3>
          <div style="padding: 10px; padding-top: 0px; max-width: 600px;">
            <h4 class="semi-title">{{ getTranslation('PAYTRAIL') }}</h4>
            <p style="margin-top: 0px; margin-bottom: 0px;">{{ getTranslation('WHEN_YOU_PRESS_YOU_WILL_GO_TO_PAYTRAIL') }}</p>
          </div>
          <div style="display: flex; flex-direction: row; padding: 10px; padding-left: 0px; padding-right: 0px;">
            <input
              :id="'termsAgreed-check'"
              type="checkbox"
              style="min-width: 40px; height: 15px; border: 1px solid rgb(160,160,160);"
              v-model="formValues['termsAgreed-check']"
              :true-value="true"
              :false-value="false"
            />
            <p style="margin: 0px;">
              {{ getTranslation('TERMS_AND_CONDITIONS_1') }}
              <a style="text-decoration: none;" :href="terms && terms.booking">{{ getTranslation('TERMS') }}</a>
              <!--{{ getTranslation('TERMS_AND_CONDITIONS_2') }}
              <a style="text-decoration: none;" :href="terms && terms.booking">{{ getTranslation('CANCELLATION_POLICY') }}</a-->
            </p>
          </div>   
        </div>

        <div style="padding: 20px;" v-if="paymentLoading">{{ getTranslation('LOADING') }}</div>
        <div style="padding: 20px; white-space: pre; margin-top: 10px; background-color: rgb(255,210,210);" v-if="proceedError">{{ proceedError }}</div>        
        <button
          v-if="checkoutPhase < 2 && !paymentLoading"
          v-on:click="changePhase(1)"
          class="pay">
          {{ getTranslation('CONTINUE') }}
        </button>
        <button
          v-if="checkoutPhase === 2 && !paymentLoading && !paymentErrors && paymentMethods.length === 0"
          :disabled="!formValues['termsAgreed-check']"
          :class="{ 'pay': true, 'inactive': !formValues['termsAgreed-check'] }"
          v-on:click="handlePayment">
          {{ getTranslation('PAY') }}
        </button>
        <div v-if="checkoutPhase === 2 && !paymentLoading && !paymentErrors && paymentMethods.length > 0">
          <h3 style="padding: 5px;">{{ getTranslation('SELECT_PAYMENT_METHOD') }}</h3>
          <div style="display: grid; grid-template-columns: repeat( auto-fit, minmax(150px, 0.33fr) );">
            <div
              v-for="paymentMethod in paymentMethods"
              :key="paymentMethod.title"
              class="box"
              style="padding: 5px; margin: 5px;">
              <div
                :class="{
                  'hover-opacity': formValues['termsAgreed-check'],
                  'not-active': !formValues['termsAgreed-check'],                  
                }"
                v-on:click="() => formValues['termsAgreed-check'] && handlePayment(paymentMethod)"
                style="display: inline;">
                <img
                  v-if="getPaymentImageUrl(paymentMethod)"
                  :src="getPaymentImageUrl(paymentMethod)"
                  style="object-fit: contain; width: 100%; max-width: 400px; max-height: 40px; padding-top: 5px; padding-bottom: 5px;" />            
                <button              
                  v-if="!getPaymentImageUrl(paymentMethod)"
                  class="pay">
                  {{ paymentMethod.title }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <button
          v-if="checkoutPhase > 0 && !paymentLoading"
          v-on:click="changePhase(-1)"
          class="back">
          {{ getTranslation('PREVIOUS') }}
        </button>
        <div style="padding: 20px; background-color: rgb(255,215,215); margin: 20px;" v-if="paymentErrors">
          <p>{{ getTranslation('SOMETHING_HAPPENED') }}</p>
          <div v-if="paymentErrors && typeof paymentErrors === 'string' && JSON.parse(paymentErrors) && JSON.parse(paymentErrors).fault && JSON.parse(paymentErrors).fault.fields" style="word-break: break-all;">
            <p>--------</p>
            <p v-if="!JSON.parse(paymentErrors).fault.message.includes('InvalidAnswersException')">
              {{ JSON.parse(paymentErrors).fault.message }}
            </p>
            <p v-for="error in JSON.parse(paymentErrors).fault.fields.errors" :key="error.path">
              {{ getTranslation(error.message) + ' - ' + error.path }}
            </p>
          </div>
        </div>
      </div>

      <!-- Sidebar, (~1/3) of screen -->       
      <div class="flex-column keep-wide" style="flex: 1;">

        <!-- Checkout phases --> 
        <div class="phase-container">
          <h3 class="box-title blue-text phase-title">{{ getTranslation('RESERVATION_STEPS') }}</h3>
          <div class="phase" :style="{ color: checkoutPhase === 0 ? '#0092C8': 'black'}">{{ getTranslation('1_QUESTIONS') }}</div>
          <div class="phase" :style="{ color: checkoutPhase === 1 ? '#0092C8': 'black'}">{{ getTranslation('2_CONTACT_PERSON') }}</div>
          <div class="phase" :style="{ color: checkoutPhase === 2 ? '#0092C8': 'black'}">{{ getTranslation('3_PAYMENT') }}</div>
        </div>

        <!-- Shopping cart -->
        <div class="box">
          <h3 class="blue-text cart-title">{{ getTranslation('SHOPPING_CART_SUMMARY') }}</h3>
          <div style="padding: 10px; padding-top: 0px;">

            <!-- Activity details -->
            <h4 class="insetted">{{ eventName }}</h4>          
            <p class="insetted" style="margin-top: 5px;" v-if="selectedDate">{{  new Date(selectedDate).getDate() + '.' + (new Date(selectedDate).getMonth() + 1) + '.' + (new Date(selectedDate).getYear() + 1900) + ' - ' + selectedTime.time }}</p> 
            <br>
            <div style="border-bottom: 1px solid rgba(0,0,0,0.1);"></div>

            <!-- Participants -->
            <h4 class="insetted">{{ getTranslation('PARTICIPANTS_IN_CART') }}</h4>
            <div style="display: flex; flex-direction: row; align-items: center;" v-for="(value, name) in participants" :key="name">          
              <p v-if="value.amount !== 0"  class="insetted" style="margin-top: 5px; flex: 1;">
                {{ value.title }} 
              </p>
              <div v-if="value.amount !== 0 && selectedRate">{{ value.amount + 'x ' + getPriceById(name, selectedRate.priceByPricingCategory) }}</div>
            </div>
            <br>
            <div style="border-bottom: 1px solid rgba(0,0,0,0.1);"></div>

            <!-- Additionals -->
            <div v-if="
            (selectedPickup && (formValues['checkbox-pickup-wanted'] || pickup.selectionType === 'PRESELECTED' )) ||
            (selectedDropoff && (formValues['checkbox-dropoff-wanted'] || dropoff.selectionType === 'PRESELECTED')) ||
            Object.values(filterExtras(formValues)).filter(_ => _).length > 0 || 
            dropoff.selectionType === 'PRESELECTED' ||
            pickup.selectionType === 'PRESELECTED'">
              <h4 class="insetted">{{ getTranslation('ADDITIONALS') }}</h4>

              <!-- No PRESELECTED pickup-->
              <div v-if="!(pickup.selectionType === 'PRESELECTED')" style="display: flex; flex-direction: row; align-items: center;">          
                <p v-if="selectedPickup && (formValues['checkbox-pickup-wanted'] || pickup.selectionType === 'PRESELECTED' )" class="insetted" style="margin-top: 5px; flex: 1;">
                  {{ getTranslation('PICK_UP') }}
                </p>
                <div v-if="selectedPickup && (formValues['checkbox-pickup-wanted'] || pickup.selectionType === 'PRESELECTED' )">
                  {{ '1x ' + (selectedPickup.pricingType === 'INCLUDED_IN_PRICE' ? '0 €' : selectedPickup.totalPrice) }}
                </div>
              </div>

              <!-- Yes PRESELECTED pickup -->
              <div v-if="pickup.selectionType === 'PRESELECTED'" style="display: flex; flex-direction: row; align-items: center;">          
                <p class="insetted" style="margin-top: 5px; flex: 1;">
                  {{ getTranslation('PICK_UP') }}
                </p>
                <div >
                  {{ '1x ' + (selectedPickup ? (
                    selectedPickup.pricingType === 'INCLUDED_IN_PRICE' ? '0 €' : selectedPickup.totalPrice
                  ) : (
                    pickup.pricingType === 'INCLUDED_IN_PRICE' ? '0 €' : pickup.totalPrice
                  ))}}
                </div>
              </div>

              <!-- No PRESELECTED dropoff-->
              <div v-if="!(dropoff.selectionType === 'PRESELECTED')" style="display: flex; flex-direction: row; align-items: center;">          
                <p v-if="selectedDropoff && formValues['checkbox-dropoff-wanted']" class="insetted" style="margin-top: 5px; flex: 1;">
                  {{ getTranslation('DROP_OFF') }}
                </p>
                <div v-if="selectedDropoff && formValues['checkbox-dropoff-wanted']">
                  {{ '1x ' + (selectedDropoff.pricingType === 'INCLUDED_IN_PRICE' ? '0 €' : selectedDropoff.totalPrice) }}
                </div>
              </div>

              <!-- Yes PRESELECTED dropoff -->
              <div v-if="dropoff.selectionType === 'PRESELECTED'" style="display: flex; flex-direction: row; align-items: center;">          
                <p class="insetted" style="margin-top: 5px; flex: 1;">
                  {{ getTranslation('DROP_OFF') }}
                </p>
                <div >
                  {{ '1x ' + (selectedDropoff ? (
                    selectedDropoff.pricingType === 'INCLUDED_IN_PRICE' ? '0 €' : selectedDropoff.totalPrice
                  ) : (
                    dropoff.pricingType === 'INCLUDED_IN_PRICE' ? '0 €' : dropoff.totalPrice
                  ))}}
                </div>
              </div>
              
              <div style="display: flex; flex-direction: row; align-items: center;" v-for="(value, name) in selectedExtras" :key="name">          
                <p v-if="value"  class="insetted" style="margin-top: 5px; flex: 1;">
                  {{ value.title }} 
                </p>
                <div v-if="value">
                  {{ (formAmounts[name] ? formAmounts[name] : 1) + 'x ' + value.priceWithDiscountAsText }}
                </div>
              </div>

              <br>
              <div style="border-bottom: 1px solid rgba(0,0,0,0.1);"></div>
            </div>
            
            <!-- Total -->
            <div style="display: flex; flex-direction: row; align-items: center;">
              <h4 class="insetted" style="flex: 1;" v-if="selectedRate && selectedRate.price">{{ getTranslation('IN_TOTAL') + ': ' }}</h4>
              <!--h4 class="insetted" v-if="selectedRate && selectedRate.price">
                {{ currencyRegexSum(selectedRate.price, ...combinedAdditionals().map(_ => _ && (_.totalPrice || _.priceWithDiscountAsText ) || []).filter(_ => _)) }}
              </h4-->
              <h4 class="insetted" v-if="options && options[0] && options[0].invoice && options[0].invoice.totalDueAsText">{{ options[0].invoice.totalDueAsText }}</h4>
            </div>  
            <div style="display: flex; flex-direction: row; align-items: center;">
              <p class="insetted" style="margin-top: 7px; flex: 1;" v-if="options && options[0] && options[0].invoice && options[0].invoice.totalIncludedTaxAsText">{{ getTranslation('INCLUDING_TAXES') + ': ' }}</p>
              <p class="insetted" style="margin-top: 7px;" v-if="options && options[0] && options[0].invoice && options[0].invoice.totalIncludedTaxAsText && typeof options[0].invoice.totalIncludedTaxAsText === 'string'">{{ '(' + options[0].invoice.totalIncludedTaxAsText + ')' }}</p>
            </div>          
          </div>
        </div>
      </div> 

      <div v-html="paymentHtmlForm" />  
    </div>
  </div>
</template>

<script>
import { isValidPhoneNumber } from 'libphonenumber-js'

export default {
  name: 'CheckoutPage',
  props: {
    eventName: String,
    selectedDate: String,
    selectedRate: Object,
    participants: Object,
    contactQuestions: Array,
    bookingQuestions: Array,
    selectedTime: Object,
    activityBookings: Array,
    pickupPlaces: Array,
    extras: Object,
    pickup: Object,
    pickupMinutesBefore: Number,
    pickupTimeByLocations: Array,
    dropoff: Object,
    totalDueAsText: String,
    paymentHtmlForm: String,
    paymentReferenceNumber: String,
    totalDue: Number,
    prebookingId: String,
    paymentLoading: Boolean,
    paymentErrors: String,
    setPaymentErrors: Function,
    getPaymentForm: Function,
    formValues: Object,
    formValidations: Object,
    formAmounts: Object,
    getTranslation: Function,
    options: Array,
    paymentFailureMessage: String,
    setPaymentFailureMessage: Function,
    selectedPickup: Object,
    selectedDropoff: Object,
    selectedExtras: Object,
    setSelectedPickup: Function,
    setSelectedDropoff: Function,
    setSelectedExtras: Function,
    filterExtras: Function,
    getPriceById: Function,
    currencyRegexSum: Function,
    combinedAdditionals: Function,
    updateShoppingCartPrices: Function,
    pickupQuestions: Array,
    dropoffQuestions: Array,
    checkoutLoading: Boolean,
    terms: Object,
    setFormValues: Function,
    sanitizeText: Function,
    areaCodes: Array,
    checkoutOptionsLoading: Boolean,
    contactPersonSameAsFirstParticipant: Boolean,
    setContactPersonSameAsFirstParticipant: Function,
    paymentMethods: Array
  },
  data: function () {
    return {
      selectedTabIndex: 0,
      checkoutPhase: 0,
      proceedError: '',
      sectionClosed: {},
      latestButtonPressed: ''
    }
  },
  methods: {  
    handlePayment: function (method) {
      this.getPaymentForm(method).then(result => {
        if (result === 'SUCCESS') {
          this.submitForm()
        }
      })
    },
    compareNationalitiesForSort: function (a, b) {
      if (b.value === 'fi_FI' || b.value === 'en_US' || b.value === 'FI') {
        return 1
      }
      if (a.value === 'fi_FI' || a.value === 'en_US' || a.value === 'FI') {
        return -1
      }
      return a.label - b.label
    },
    getPaymentImageUrl: function (paymentMethod) {
      //if (paymentMethod.id === 'VM') return 'https://img.paytrail.com/index.svm?type=horizontal&cols=10&text=0&auth=e713951c942be7a7&id=28137'
      //if (paymentMethod.id === 'VMLK') return 'https://img.paytrail.com/index.svm?type=horizontal&cols=10&text=0&auth=b7230f66bddf0062&id=33234'
      return paymentMethod.logo
      //return null
    },
    setLatestButtonPressed: function (id) {
      this.latestButtonPressed = id
    }, 
    checkExtras: function () {
      this.setSelectedExtras(this.filterExtras(this.formValues))
    },
    handleSectionClick: function (target) {
      this.sectionClosed = { ...this.sectionClosed, [target]: !this.sectionClosed[target] }
    },
    onlyUniqueInArray: function (value, index, self) {
      return self.indexOf(value) === index;
    },
    parseToNum: function (str) {      
      return str && str.split[' '][0]
    },
    changePhase: function (change) {
      if ((this.checkoutPhase + change) === -1) {
        this.$emit('toggleCheckout')
      }
      if (change === -1) {
        this.checkoutPhase = this.checkoutPhase + change
        this.proceedError = ''
        this.setPaymentErrors('')
        this.setPaymentFailureMessage('')
        window.scrollTo(0,0)
        return
      }      
      if (this.checkIfRequiredFieldFilled()) {
        this.checkoutPhase = this.checkoutPhase + change
        this.proceedError = ''
        window.scrollTo(0,0)
      } else {
        // get shadowRoot Elements if applicable
        let requiredClassElements = document.querySelectorAll('.required')
        let requirementsFilledClassElements = document.querySelectorAll('.requirements-filled')
        if (!requiredClassElements || requiredClassElements.length === 0) {
          const wacsElement = document.getElementsByTagName('wacs-widget') && document.getElementsByTagName('wacs-widget')[0]
          if (wacsElement && wacsElement.shadowRoot) {
            requiredClassElements = wacsElement.shadowRoot.querySelectorAll('.required')
          }         
        }
        if (!requirementsFilledClassElements || requirementsFilledClassElements.length === 0) {
          const wacsElement = document.getElementsByTagName('wacs-widget') && document.getElementsByTagName('wacs-widget')[0]
          if (wacsElement && wacsElement.shadowRoot) {
            requirementsFilledClassElements = wacsElement.shadowRoot.querySelectorAll('.requirements-filled')
          }         
        }

        // Validation errors to show        
        const requiredIds = [].slice.call(requiredClassElements).map(_ => _.id)
        const requirementsFilledIds = [].slice.call(requirementsFilledClassElements).map(_ => _.id)
        const unfilled = requiredIds.filter(_ => !requirementsFilledIds.includes(_))
        // Hacky way to change all input names
        const prettified = unfilled
          .map(_ => {
            return _
              .replace(/passenger/g, this.getTranslation('PARTICIPANT'))
              .replace(/question-/g, '')
              .replace('-', ' ')
              .replace('-', ' - ')
              .replace(/email/g, this.getTranslation('EMAIL'))
              .replace(/dateOfBirth/g, this.getTranslation('BIRTHDAY'))
              .replace(/firstName/g, this.getTranslation('FIRST_NAME'))
              .replace(/lastName/g, this.getTranslation('LAST_NAME'))
              .replace(/phoneNumber/g, this.getTranslation('PHONE_NUMBER'))
              .replace(/[0-9]{4}/g, ' ' + this.getTranslation('QUESTIONS'))
              .replace(/questions/g, this.getTranslation('RESERVATION_-'))
              .replace(/checkbox/g, '')
              .replace(/input/g, '')
              .replace(/ booking - /g, '')
              .replace(/extra/g, this.getTranslation('EXTRA'))
              .replace(/extr/g, this.getTranslation('EXTRA'))
              .replace(/indExtra/g, this.getTranslation('EXTRA'))
              .replace(/- select/g, '')
              .replace(/ pickup/g, this.getTranslation('PICKUP'))
              .replace(/pickup/g, this.getTranslation('PICKUP'))
              .replace(/ dropoff/g, this.getTranslation('DROP_OFF'))
              .replace(/dropoff/g, this.getTranslation('DROP_OFF'))
              .replace(/amount/g, this.getTranslation('AMOUNT'))
              .replace(/question/g, this.getTranslation('QUESTIONS') + ' ')
              .replace(/question.+/g, this.getTranslation('QUESTIONS'))
              .replace(/mainContactDetails/g, this.getTranslation('CONTACT_PERSON'))
              .replace(/ Extra/g, 'Extra ')
              .replace(/Extra.+ Questions/g, 'Extra - Questions')
              .replace(/Extra {2}-.+/g, 'Extra - Questions')
              .replace(/Extra-[0-9]+-/g, 'Extra - ')
              .replace(/Extra-.+/g, 'Extra - Questions')
              .replace(/Reservation - .+/g, 'Reservation - Questions')
              .replace(/Varaus - .+/g, 'Varaus - Kysymyksiä')
              .replace(/ Lisäpalvelu/g, 'Lisäpalvelu ')
              .replace(/Lisäpalvelu.+ Kysymyksiä/g, 'Lisäpalvelu - Kysymyksiä')
              .replace(/Lisäpalvelu {2}-.+/g, 'Lisäpalvelu - Kysymyksiä')
              .replace(/Lisäpalvelu-[0-9]+-/g, 'Lisäpalvelu - ')
              .replace(/Lisäpalvelu-.+/g, 'Lisäpalvelu - Kysymyksiä')
              .replace(/Kuljetus Questions.+/g, 'Siirtyminen - Kysymyksiä')
              .replace(/12/g, '13')
              .replace(/11/g, '12')
              .replace(/10/g, '11')
              .replace(/9/g, '10')
              .replace(/8/g, '9')
              .replace(/7/g, '8')
              .replace(/6/g, '7')
              .replace(/5/g, '6')
              .replace(/4/g, '5')
              .replace(/3/g, '4')
              .replace(/2/g, '3')
              .replace(/1/g, '2')
              .replace(/0/g, '1')
          })
          .filter(this.onlyUniqueInArray)

        this.proceedError = this.getTranslation('FILL_ALL_REQUIRED_FIELDS') + '\n\n' + prettified.join('\n')
        return
      }
      if (this.checkoutPhase === 1) {
        this.autofillContactPersonFromParticipants()
        /* Autofill only when checkbox checked
        if (this.contactPersonSameAsFirstParticipant) {
          this.autofillContactPersonFromParticipants()
        } */

       }
      if (this.checkoutPhase === 2) {
        /*
        this.getPaymentForm().then(result => {
          console.log('Got payment form getting result:', result)
        })
        */
        window.scrollTo(0,0)
        return
      }
    },
    checkIfRequiredFieldFilled: function () {
      // get shadowRoot Elements if applicable
      let requiredClassElements = document.getElementsByClassName('required')
      let requirementsFilledClassElements = document.getElementsByClassName('requirements-filled')
      if (!requiredClassElements || requiredClassElements.length === 0) {
        const wacsElement = document.getElementsByTagName('wacs-widget') && document.getElementsByTagName('wacs-widget')[0]
        if (wacsElement && wacsElement.shadowRoot) {
          requiredClassElements = wacsElement.shadowRoot.querySelectorAll('.required')
        }         
      }
      if (!requirementsFilledClassElements || requirementsFilledClassElements.length === 0) {
        const wacsElement = document.getElementsByTagName('wacs-widget') && document.getElementsByTagName('wacs-widget')[0]
        if (wacsElement && wacsElement.shadowRoot) {
          requirementsFilledClassElements = wacsElement.shadowRoot.querySelectorAll('.requirements-filled')
        }         
      }

      const requiredAmount = requiredClassElements.length
      const filledAmount = requirementsFilledClassElements.length

      return requiredAmount === filledAmount
    },
    validateInput: function (field, target) {
      const targetValue = this.formValues[target]

      if (!field) {
        this.formValidations[target] = true
        return
      }

      // Formats
      if (field.dataFormat === 'LANGUAGE') {
        this.formValidations[target] = !!targetValue
        return 
      }
      if (field.dataFormat === 'EMAIL_ADDRESS') {
        this.formValidations[target] = targetValue && !!targetValue.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-.]+\.[a-zA-Z0-9-][a-zA-Z0-9-]+$/)
        return 
      }
      if (field.dataFormat === 'PHONE_NUMBER') {        
        let areacodeTarget = target.replace('phoneNumber', 'areacode');    
        const areacode = this.formValues[areacodeTarget] || '';   
        const completeNumber = areacode + targetValue
        this.formValidations[target] = completeNumber && isValidPhoneNumber(completeNumber) //!!targetValue.match(/^\+?[0-9 ]+$/)        
        return 
      }

      // Types
      if (field.dataType === 'DATE') {
        this.formValidations[target] = targetValue && !!targetValue.match(/^\d{2}[.]{1}\d{2}[.]{1}\d{4}$/)
        return 
      }
      if (field.dataType === 'SHORT_TEXT') {
        this.formValidations[target] = !!targetValue && targetValue.length > 0
        return
      }
      if (field.dataType === 'OPTIONS') {
        this.formValidations[target] = targetValue !== undefined && targetValue !== ''
        return
      }
      if (field.dataType === 'BOOLEAN') {
        this.formValidations[target] = targetValue !== undefined && targetValue !== ''
        return
      }
      this.formValidations[target] = true
      return
    },
    setSelectedTabIndex: function (index) {
      this.selectedTabIndex = index
    },
    autofillContactPersonFromParticipants: function () {
      const phoneNumberArray = this.contactQuestions.filter(_ => _.dataFormat === 'PHONE_NUMBER')

      let contactPersonAskedFields = Object.values(this.contactQuestions.map(_ => _.questionId))
      if (phoneNumberArray && phoneNumberArray.length > 0) {
        contactPersonAskedFields = [ ...contactPersonAskedFields, 'areacode' ]
      }
      const firstPassengerAskedFields = contactPersonAskedFields.map(_ => ({ [_]: this.formValues['passenger-0-question-' + _]})).reduce((acc, value) => ({ ...acc, ...value }), {})

      // apply gotten values
      Object.keys(firstPassengerAskedFields).forEach(_ => {

        // Remove contactFieldValue and the if-statement to return checkbox functionality
        const contactFieldValue = this.formValues['mainContactDetails-' + _]        
        if (!contactFieldValue) {
          this.formValues['mainContactDetails-' + _] = firstPassengerAskedFields[_]
        }
      })
      this.setFormValues(JSON.parse(JSON.stringify(this.formValues)))
      this.contactQuestions.forEach(_ => {
        this.validateInput(_, 'mainContactDetails-' + _.questionId)
      })
    },
    submitForm: function () {
      // get shadowRoot Elements if applicable
      let paymentFormElement = document.getElementById('payment-form')
      if (!paymentFormElement) {
        const wacsElement = document.getElementsByTagName('wacs-widget') && document.getElementsByTagName('wacs-widget')[0]
        if (wacsElement && wacsElement.shadowRoot) {
          paymentFormElement = wacsElement.shadowRoot.getElementById('payment-form')
        }         
      }

      if (paymentFormElement) {
        paymentFormElement.submit()
      }
    },    
    getTooltip: function (question) {

      // Formats
      if (question.dataFormat === 'LANGUAGE') {
        return false
        //return this.getTranslation('CHOOSE_A_LANGUAGE')
      }
      if (question.dataFormat === 'EMAIL_ADDRESS') {
        return 'example@address.com'
      }
      if (question.dataFormat === 'PHONE_NUMBER') {
        return false
        //return this.getTranslation('ALL_TOGETHER')
      }

      // Types
      if (question.dataType === 'DATE') {
        return 'dd.mm.yyyy'
      }
      if (question.dataType === 'SHORT_TEXT') {       
        return false
      }
      return false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.transportation-questions-container {
  padding: 5px;
}
.item-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(274px, 1fr));
  
}
.item-container {
  padding: 10px;
}
.passenger-information {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(274px, 1fr));
  padding-top: 10px;
}
.extra-container {
  position: relative;
  border: 1px solid rgb(245,245,245);
  padding-left: 15px;
  padding-right: 15px;
}
.checkbox-btn {
  background-color: #0092C8;
  color: white;
  padding: 10px;
  padding-left: 20px;
  padding-right: 20px;
}
.extra-button {
}
.pricing-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 15px;
  padding-bottom: 25px;
}
.item-additional-info {
}
.item-additional-info-separator {
  border-bottom: 1px solid rgb(230,230,230);
  margin-bottom: -13px;
}
.collapsed-dropdown-header {
  border-bottom: 0px !important;
}
.item-information {
  min-height: 100px;
}
.delete-mode {
  background-color: red;
}
.checkout-loading-img {
  height: 35px;
  width: 35px;
  object-fit: contain;
  padding: 0px;
  margin: 0px;
  margin-top: -25px;
  margin-right: 15px;
  opacity: 1;
  position: relative;
  top: 10px;
  right: -10px;
}
.collapsed {
  background-color: red;
  height: 0px;
  overflow: hidden;
  padding-bottom: 0px;
  padding-top: 0px;
}
.passenger-content-container {
  padding: 10px;
  padding-bottom: 10px;
  animation-name: fade-in;
  animation-duration: 0.7s;
  border-bottom: 1px solid rgb(230,230,230);
}
.passenger-title-container {
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid rgb(230,230,230);
}
.passenger-title-container:hover {
  opacity: 0.7;
}
.passenger-title-container-2 {
  padding-left: 10px;
  padding-right: 10px;
  background-color: #0092C8;
  color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid rgb(0,137,190);
}
.checkout {
  animation-name: fade-in;
  animation-duration: 2s;
}
.inactive {
  background-color: rgb(210,210,210) !important;
}
.not-active {
  opacity: 0.5;
}
.required {
  background-color: rgba(255,240,240);
}
.requirements-filled {
  background-color: white;
}
.keep-wide {
  min-width: 350px;
}
.areacode-select {
  width: 88px;
  min-width: 88px;
  height: 37.5px;
}
.semi-title {
  margin-bottom: 10px;
}
.mandatory-button {
  background-color: rgb(180,180,180);
  cursor: not-allowed;
}
.editing-disabled {
  opacity: 0.7;
  background-color: rgb(240,240,240);
  cursor: not-allowed;
}
.arrow {
  height: 25px;
  width: 40px;
  object-fit: contain;
  margin-top: 35px;
}
.arrow:hover {
  opacity: 0.7;
}
.phase {
  text-align: left;
}
.phase-container {
  padding-left: 15px;
  padding-top: 10px;
  padding-bottom: 25px;
}
.phase-title {
  margin-bottom: 10px;
}
.cart-title {
  background-color: rgb(51, 51, 51);
  color: white;
  margin-top: 0px;
  padding: 15px;
  font-size: 16px;
}
.widget-content {
  padding: 10px;
}
.back {
  background-color: red;
  border: 0px;
  color: white;
  padding: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: 600;
  text-transform: uppercase;
  margin-top: 10px;
  margin-left: 10px;
}
.generic-button {
  background-color: #0092C8;
  border: 0px;
  color: white;
  padding: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: 600;
  margin-top: 10px;
  margin-left: 10px;
}
.flex-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.flex-column {
  padding: 15px;
}
.pay {
  background-color: #0092C8;
  border: 0px;
  color: white;
  padding: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: 600;
  text-transform: uppercase;
  margin-top: 15px;
}
.personal-information {
  margin-right: 5px;
  margin-bottom: 5px;
}
.insetted {
  margin-bottom: 0px;
}
h4 {
  font-weight: 600;
}

.tooltip-container {
  position: relative;
  display: inline-block;
  padding-left: 10px;
}
.checkout-loading {
  position: fixed;
  bottom: 60px;
  right: 20px;
  z-index: 1000;
}

@keyframes anim {
  from {background-color: #0092C8;}
  to {background-color: white;}
}

@keyframes anim2 {
  from {opacity: 0;}
  to {opacity: 1;}
}

.animate-render {
  animation-name: anim2;
  animation-duration: 2s;
  border-radius: 2px;
}

/* Tooltip text */
.tooltip-container .tooltip {
  visibility: hidden;
  width: 200px;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
 
  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1;

  width: 200px;
  top: 100%;
  left: 50%;
  margin-left: -100px; /* Use half of the width (120/2 = 60), to center the tooltip */
}

.hover-opacity:hover {
  opacity: 0.7;
  cursor: pointer;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip-container:hover .tooltip {
  visibility: visible;
}
@media only screen and (max-width: 450px) {
  .keep-wide {
    min-width: 250px;
  }
}
</style>
